import { render, staticRenderFns } from "./DepositView.vue?vue&type=template&id=fe124d22&"
import script from "./DepositView.vue?vue&type=script&lang=js&"
export * from "./DepositView.vue?vue&type=script&lang=js&"
import style0 from "./DepositView.vue?vue&type=style&index=0&id=fe124d22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports